export const findDiscount = (price, salePrice) =>
  price === salePrice ? 0 : price - salePrice;

export const getVariants = (productOptions) => {
  if (!Array.isArray(productOptions) || productOptions.length === 0) {
    return ""; // Return empty string if no variants
  }

  return productOptions
    .map((option) => option.value)
    .filter(Boolean)
    .join(", "); //Return comma separate string. Eg: "black, 50cm"
};

export const getSelectedVariants = (productOptions) => {
  if (!Array.isArray(productOptions) || productOptions.length === 0) {
    return "";
  }

  return productOptions
    .map((group) => group?.values?.find((value) => value?.selected)?.name)
    .filter(Boolean)
    .join(", ");
};

export const getItemCategories = (categories, maxDepth = 5) => {
  const safeCategories = Array.isArray(categories) ? categories : [];
  const categoryObject = {};
  for (let i = 0; i < maxDepth; i++)
    categoryObject[`item_category${i || ""}`] = safeCategories[i]?.name || "";
  return categoryObject;
};

export const formatItems = (products, couponName) => {
  return products?.map((product, index) => {
    return {
      item_name: product?.name,
      item_id: product?.sku,
      price: product?.price,
      item_brand: product?.brand || "",
      item_category: "",
      discount: findDiscount(product?.price, product?.salePrice),
      item_variant: getVariants(product?.productOptions),
      item_list_id: "",
      item_list_name: "",
      ...getItemCategories(product?.categories),
      quantity: product?.quantity,
      index: index,
      affiliation: "",
      coupon: couponName || "",
    };
  });
};
